import { createContext } from 'react';

import { DEFAULT_EXPORT_CONTEXT } from './constants';
import { SalesforceExportContextType } from './types';

export const SalesforceExportContext = createContext<
  SalesforceExportContextType
>(DEFAULT_EXPORT_CONTEXT);
